<script>
export default {
  name: "Modal",
  data() {
    return {};
  },
  created() {},
  mounted() {
    if (this.dismissible) {
      document.addEventListener("keydown", this.onKeydown);
    }
    if (this.autoClose > 0) {
      this.autoCloseTimer = setTimeout(() => {
        this.$emit("close");
      }, this.autoClose)
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
    clearTimeout(this.autoCloseTimer)
  },
  methods: {
    onKeydown(e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        this.$emit("close");
      }
    },
    onBackdropClick() {
      if (this.dismissible) {
        this.$emit("close");
      }
    },
  },
  props: {
    size: {
      default: "md",
    },
    // Cho phép đóng modal khi click nền tối hoặc nhấn Esc
    dismissible: {
      type: Boolean,
      default: false,
    },
    // Số ms trước khi modal tự động đóng. 0 (mặc định) = không tự đóng
    autoClose: {
      type: Number,
      default: 0
    },
  },
};
</script>
<template>
  <transition name="modal">
    <div class="modal-mask" @click.self="onBackdropClick">
      <div v-bind:class="['modal-container', size]">
        <div class="modal-header">
          <slot name="header">Modal Header</slot>
        </div>
        <div class="modal-body">
          <slot name="body"> Modal Body</slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button class="modal-default-button" @click="$emit('close')">
              Close
            </button>
            <button class="modal-default-button" @click="$emit('confirm')">
              OK
            </button>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<style lang="sass">
$title-color: #BE185A
.modal-enter
    opacity: 0
.modal-leave-active
    opacity: 0
.modal-enter .modal-container,
.modal-leave-active .modal-container
    -webkit-transform: scale(1.1)
    transform: scale(1.1)
.modal-mask
    position: fixed
    z-index: 9998
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, 0.4)
    display: flex
    justify-content: center
    align-items: center
    transition: opacity 0.3s ease
.modal-container
    display: flex
    flex-direction: column
    margin: 0px auto
    background-color: #fff
    border-radius: 1em
    box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25)
    transition: all 0.3s ease
    box-sizing: border-box
    .modal-header,.modal-body,.modal-footer
      border: none
    .modal-header
      color: $title-color
      padding: 1em 1em 0em 1em
      p
        margin: 0
        font-size: 1.5em
    .modal-body
      padding: 1.25em
    .modal-footer
      padding: 0em 1em 1em 1em
      display: block
      .btn
        padding: 0.5em 1em
        font-size: 12px
// Popup (chuẩn MASTER MANAGER POPUP RULE): rộng cố định 512px,
// full-width khi màn hình nhỏ hơn 512px
.modal-container.popup
    width: 512px
    @media (max-width: 511.98px)
        width: 100vw
        border-radius: 0
// Small (sm): 300px — cảnh báo đơn giản 1–2 dòng + nút bấm
.modal-container.sm
    width: 90vw
    max-width: 300px
// Medium (md) — default: 500px — form/màn hình cài đặt đơn giản
.modal-container.md
    width: 90vw
    max-width: 500px
// Large (lg): 800px — bảng lịch sử giao dịch, layout nhiều tab, điều khoản dài
.modal-container.lg
    width: 90vw
    max-width: 800px
</style>
